module.exports = __webpack_public_path__ + "img/1289197214.e23d9902.jpg";